// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/enum-bug-keys.js
// module id = 352
// module chunks = 1